import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface FinanceSummary {
  totalRevenue: number;
  totalParts: number;
  totalLabor: number;
  totalOutsourced: number;
  completedCount: number;
}

export interface FinanceOrder {
  id: string;
  number: number;
  date: string;
  plate: string;
  vehicleName: string;
  total: number;
  status: string;
}

export interface FinanceChartPoint {
  date: string;
  revenue: number;
}

interface FinanceData {
  summary: FinanceSummary;
  orders: FinanceOrder[];
  chartData: FinanceChartPoint[];
}

interface UseFinanceOptions {
  from: string;
  to: string;
  mechanicId?: string;
}

export function useFinance(opts: UseFinanceOptions) {
  return useQuery<FinanceData>({
    queryKey: ['finance', opts.from, opts.to, opts.mechanicId],
    queryFn: async () => {
      const params = new URLSearchParams({ from: opts.from, to: opts.to });
      if (opts.mechanicId) params.set('mechanicId', opts.mechanicId);
      const res = await api.get(`/workshops/my/finance?${params}`);
      return res.data;
    },
  });
}
